<!--This is the introductory component of every department child page (as well as some
    non-department pages). Contains image, logo, title, and optional subtitle. Department
    pages will additionally have a Department homepage link.
-->

<template>
  <div>
    <mdb-parallax :src="`${image_url}`" height="half" factor="1.5" class="p-0 d-none d-lg-block">
      <mdb-mask overlay="black-slight">
        <mdb-row class="fixed-bottom mb-2">
          <mdb-col>

            <!--Image for large screens-->

            <img
              alt="Washoetribe logo"
              class="img-fluid mx-auto mb-5"
              :src="`${logo_url}`"
              style="width: 250px;"
            />
          </mdb-col>
        </mdb-row>
      </mdb-mask>
    </mdb-parallax>

    <!--Static PageHeader image with logo for mobile devices (includes ipad b/c of safari issue)-->

    <div :style="{ 'background-image': 'url(' + image_url + ')' }" style="height: 300px; background-position: center;" class="d-md-block d-lg-none">
      <mdb-mask>
        <mdb-container>
          <mdb-row>
            <mdb-col>
              <img 
                alt="Washoetribe Logo"
                class="img-fluid mx-auto mt-5 pt-5"
                :src="`${logo_url}`"
                style="width: 150px;"
              />
            </mdb-col>
          </mdb-row>
        </mdb-container>
      </mdb-mask>
    </div>

    <mdb-jumbotron class="white-text mb-0 text-center primary-color"> 
      <h2 class="h1-responsive font-weight-bold mt-4">{{title}}</h2>
      <hr />
      <p v-if="subtitle" class="text-center">{{subtitle}}</p>
    </mdb-jumbotron>

    <!--Link to department home IF page is a department -->

    <mdb-container v-if="dept_link">
      <mdb-row class="text-right pt-3">
        <mdb-col>
          <router-link class="default" :to="dept_link">
            <mdb-icon icon="home" class="mr-2" />Department Home Page
          </router-link>
        </mdb-col>
      </mdb-row>
    </mdb-container>
  </div>
</template>

<script>
import {
  mdbParallax,
  mdbMask,
  mdbJumbotron,
  mdbContainer, 
  mdbRow,
  mdbCol,
  mdbIcon,
} from "mdbvue"
export default {
  name: "PageHeader",
  props: {
    title: String,
    subtitle: String,
    logo_url: String,
    image_url: String,
    dept_link: String
  },
  components: {
    mdbParallax,
    mdbMask,
    mdbJumbotron,
    mdbContainer, 
    mdbRow,
    mdbCol,
    mdbIcon,
  }
}
</script>
